import { CardType } from '../../types/cardType';

export const withdrawCreditTimeGroupOne = [
  CardType.AstropayWallet,
  CardType.EcoPayZ,
  CardType.GamersCard,
  CardType.InstaDebit,
  CardType.Interac,
  CardType.LuxonPay,
  CardType.MBookers,
  CardType.MuchBetter,
  CardType.Neteller2,
  CardType.Pay4Fun,
  CardType.PayPal,
  CardType.Paytm,
  CardType.Pix,
  CardType.QiwiWallet,
  CardType.Resort,
  CardType.Skrill1Tap,
  CardType.WebMoney
];

export const withdrawCreditTimeGroupTwo = [CardType.PsPayAstropay];

export const withdrawCreditTimeGroupThree = [
  CardType.NemkontoCashout,
  CardType.WireCashout,
  CardType.DBT
];

export const withdrawCreditTimeGroupFour = [
  CardType.ApplePay,
  CardType.ECheck,
  CardType.GooglePay,
  CardType.MasterCard,
  CardType.Solo,
  CardType.Visa
];

export const withdrawHidePrefix = [CardType.AstropayWallet];
